(function ($) {

  $('.page-header-profile__location .link--cta').click(function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top-125
    }, 600);
  });

})(jQuery);
